import { useContext, createContext } from 'react';

export const UpperAndLowerContext = createContext({
    uiContext: {
        expanded: false,
        handleExpand: () => undefined,
        impressionType: '',
    },
    formContext: {
        control: {},
        errors: {},
        formValues: {},
        dirtyFields: {},
        resetField: () => undefined,
        setValue: () => undefined,
        trigger: () => undefined,
    },
});

const useUpperAndLowerContext = () => {
    const context = useContext(UpperAndLowerContext);
    if (!context) {
        throw new Error('context must be used within a Context Provider');
    }
    return context;
};

export default useUpperAndLowerContext;
